(function () {
    'use strict';

    angular.module('swif.framework')
    .directive('swifContentTitle', swifContentTitle);


    /**
     * @ngdoc directive
     * @name swif.framework:swifContentTitle
     * @module swif.framework
     * @restrict EA
     * @description display the main title of a page with tools (list actions + filter + views counter ...)
     * @usage
     * ```
     *  <div
           swif-content-title="Reservation Requests"
           ng-model="reservationRequests"
           col-title="6"
           count-filter="countFilter"
           actions-mode="buttons-dropdown"
           pre-modal="preModal"
           pre-validate="actionModalsPreValidate"
           callback="actionsCallback">
        </div>
        ```
    **/
    function swifContentTitle($q, swif) {
        'ngInject';
        return {
            restrict: 'EA',
            require: '?ngModel',
            replace: true,
            transclude: true,
            scope: {
                swifContentTitle: '@',
                colTitle: '@?',
                type: '@',
                countFilter: '=?',
                callback: '=?',
                preModal: '=?',
                preValidate: '=?',
                displayViews: '=?',
                displayList: '=?',
                displaySearch: '=?',
                displayBadges: '=?',
                hideList: '@?',
                actionsMode: '@?',
                actionViewsCategory: '@?',
                refreshCollectionsIds: '<?'
            },
            link: link,
            templateUrl: 'partials/ui/header.html'
        };
        function link(scope, element, attr, ngModel) {
            if (_.isUndefined(scope.displayViews)) {
                scope.displayViews = true;
            }
            if (_.isUndefined(scope.displayList)) {
                scope.displayList = (scope.callback && scope.hideList != 'true') ? true:false;
            }
            if (_.isUndefined(scope.displaySearch)) {
                scope.displaySearch = scope.callback ? true:false;
            }
            if (_.isUndefined(scope.displayBadges)) {
                scope.displayBadges = true;
            }
            if (_.isUndefined(scope.actionViewsCategory)) {
                scope.actionViewsCategory = 'views';
            }
            if (_.isUndefined(scope.actionsMode)) {
                scope.actionsMode = 'buttons-dropdown';
            }
            scope.loading = {items: {}};
            if (!scope.colTitle) {
                scope.colTitle = 4;
            } else {
                scope.colTitle = parseInt(scope.colTitle, 10);
            }
            if (scope.swifContentTitle) {
                swif.settings.page.title = scope.swifContentTitle;
            }

            scope.smsFeature = swif.settings.app.features.sms;
            scope.firstCol = 'col-md-' + scope.colTitle;
            scope.secondCol = 'col-md-' + (8 - scope.colTitle);
            scope.countFilter = scope.countFilter || {};
            var getCount = function (filter) {
                return swif.data.getContentRange(scope.collection.contentType, filter);
            };
            var addBadge = function (filter, type) {
                var badge = {
                    type: type,
                    filter: filter,
                    count: 0
                };
                scope.counters.push(badge);
                if (scope.collection.currentFilter && !filter.fields) {
                    filter.fields = scope.collection.currentFilter.fields;
                }
                getCount(filter).then(function (count) {
                    if (count !== undefined) {
                        _.forEach(scope.counters, function (counter) {
                            if (counter.filter === filter) {
                                counter.count = count;
                            }
                        });
                    }
                });
            };
            var initCountValues = function () {
                //reset
                scope.counters = [];
                _.forOwn(scope.countFilter, function (filter, key) {
                    addBadge(filter, key);
                });
            };

            scope.$watch('collection.currentFilter', function (newV, oldV) {
                if(!angular.equals(newV, oldV)) {
                    initCountValues();
                }
            }, true);

            if (ngModel !== null) {
                ngModel.$render = function () {
                    scope.collection = ngModel.$viewValue;
                    if (scope.collection) {
                        initCountValues();
                    }
                };
            } else {
                scope.collection = {
                    contentType: scope.type
                };
            }

            scope.setCurrentFilter = function (filter) {
                delete filter.refresh;
                scope.collection.currentFilter = angular.copy(filter);
                initCountValues();
            };
            scope.refresh = function () {
                swif.message.loading(scope.loading.items);
                var promises = [];
                if (scope.refreshCollectionsIds) {
                    scope.refreshCollectionsIds.forEach((id) => {
                        promises.push(swif.collections.getItems(id));
                    });
                } else if (scope.collection) {
                    promises.push(scope.collection.getItems());
                }
                $q.all(promises)
                .then(function () {
                    swif.message.loading(scope.loading.items, 'ok');
                }, function () {
                    swif.message.loading(scope.loading.items, 'ko');
                });
            };
        }
    }

})();
